import React from 'react';

const Marker = ({
    className,
    destinationSlug,
    countrySlug,
    propertySlug,
    searchId,
    name,
    location,
    path,
    thumbnail,
    lowestPrice,
    onMarkerSelect,
    onMarkerDismiss,
    isActiveMarker,
    isInTransition,
}) => (
    <div
        className={className}
        onMouseEnter={onMarkerSelect}
        onMouseLeave={onMarkerDismiss}
        data-active={isActiveMarker}
        data-fixed={isInTransition}
        // eslint-disable-next-line indent
    >
        <img
            src="https://www.google.co.uk/maps/vt/icon/name=assets/icons/spotlight/spotlight_pin_v4_outline-1-small.png,assets/icons/spotlight/spotlight_pin_v4-1-small.png,assets/icons/spotlight/spotlight_pin_v4_dot-1-small.png&highlight=c5221f,ea4335,b31412?scale=2"
            alt=""
            className="marker"
        />
        <section className="popover">
            <a
                className="popover-link"
                target="_blank"
                href={
                    path ||
                    `/hotels/${countrySlug}/${destinationSlug}/${propertySlug}.html?sid=${searchId}`
                }
                rel="noreferrer"
            >
                {thumbnail ? (
                    <img className="popover-img" src={thumbnail?.url} alt="" />
                ) : null}
                <div className="popover-details">
                    <h2 className="popover-location">
                        {name}
                        {location ? <small>{location}</small> : null}
                    </h2>
                    {lowestPrice ? (
                        <span className="popover-price">
                            from{' '}
                            <span className="popover-price-value">
                                £{lowestPrice}
                            </span>
                        </span>
                    ) : null}
                </div>
            </a>
            {/* <button className="popover-close" onClick={onMarkerDismiss}>
                    <Icon type="plus" width="16" height="16" />
                </button> */}
        </section>
    </div>
);

export default Marker;
